import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../Poster/Poster.css';

const Poster = () => {
    const handleCall = () => {
        window.location.href = `tel:"02038852600"`;
    };
    
    //* Slider settings*
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000, // Changed from 3000 to 2000 (2 seconds)
        cssEase: 'linear',
    };
    
    //* Array of images for the slider*
    const images = [
        '/ss1.jpg',
        '/ss2.jpg',
        '/ss3.jpg',
        '/ss4.jpg',
        '/s9.jpg',
    ];
    
    return (
        <div className="poster-containerh">
            {/** Slider **/}
            <Slider {...settings}>
                {images.map((image, index) => (
                    <div key={index}>
                        <img src={image} alt={`Poster ${index + 1}`} className="poster-imageh" />
                    </div>
                ))}
            </Slider>
            
            {/** Overlay Content **/}
            <div className="overlay-left">
                <h1>Budget-Friendly, Adventure-Ready</h1>
                <button className="book-noww" onClick={handleCall}>Book Now</button>
            </div>
            
            {/** Card Logos **/}
            <div className="overlay-card">
                <div className="card-logos">
                    <img src="/visa.png" alt="Card 1" className="card-logo" />
                  
                    <img src="/american.png" alt="Card 3" className="card-logo" />
                    <img src="/mastercard.png" alt="Card 4" className="card-logo" />
                </div>
            </div>
            
            {/** Text Bar at Bottom **/}
            <div className="text-bar">
                <p className='p-textbar'>Book your Favorite Flights Below</p>
            </div>
        </div>
    );
};

export default Poster;